import Box from '../Box'
import Modal, { Props as ModalProps } from '../Modal'
import Text from '../Text'
import Spinner from '../Spinner'

interface Props extends Omit<ModalProps, 'visible' | 'isFooterVisible'> {
  message?: string
  visible?: boolean
}

const LoadingModal = ({
  children,
  visible = true,
  minWidth = '400px',
  minHeight = '300px',
  message = 'Loading...',
  ...props
}: Props) => (
  <Modal visible={visible} isFooterVisible={false} minWidth={minWidth} minHeight={minHeight} {...props}>
    {children ?? <DefaultContent message={message} />}
  </Modal>
)

const DefaultContent = ({ message }: { message: string }) => (
  <Box display="flex" flexDirection="column" gap="1.5rem" justifyContent="center" alignItems="center">
    <Spinner fontSize={80} />
    <Text>{message}</Text>
  </Box>
)

export default LoadingModal
